module.exports = __webpack_public_path__ + "static/media/all-icon.c55a683f.svg";